/**
 * Perfil para Vol3D: off | mip (el viewport usa WebGL2 TEXTURE_3D si hay GPU).
 * Independiente de MPR light: un teléfono que hace Orthogonal puede no hacer 3D.
 */
import { getResourceHints } from './mobileDownloadProfile'

const MiB = 1024 * 1024

export function hasWebGl() {
  if (typeof document === 'undefined') return false
  try {
    const c = document.createElement('canvas')
    return !!(c.getContext('webgl') || c.getContext('experimental-webgl'))
  } catch (e) {
    return false
  }
}

/** Bytes: HU Int16 + Uint8 N³ (CPU) + copia GPU + overhead. */
export function estimateMpr3dBytes(n, extraMask) {
  const N = Math.max(32, Number(n) || 128)
  return N * N * N * (extraMask ? 4 : 3) + 12 * MiB
}

export function resolveMpr3dSize(hints) {
  const h = hints || getResourceHints()
  // Un poco más cerca de la resolución MPR (máx. 256³ por límite WebGL/RAM).
  if (h.phone) return 176
  if (h.constrained) return 208
  if (h.deviceMemory != null && h.deviceMemory >= 8) return 256
  if (h.deviceMemory != null && h.deviceMemory >= 4) return 240
  return 208
}

/**
 * @param {{ cols?: number, rows?: number, nSlices?: number, mprBlocked?: boolean, hints?: object, sessionOff?: boolean }} args
 * @returns {'off'|'mip'}
 */
export function resolveMpr3dProfile({
  cols,
  rows,
  nSlices,
  mprBlocked,
  hints,
  sessionOff,
} = {}) {
  if (sessionOff) return 'off'
  if (mprBlocked) return 'off'
  const h = hints || getResourceHints()
  if (!hasWebGl()) return 'off'

  const n = resolveMpr3dSize(h)
  const extra = estimateMpr3dBytes(n)
  const cap = h.phone ? 48 * MiB : h.constrained ? 56 * MiB : 64 * MiB
  if (extra > cap) return 'off'

  const voxels = Math.max(1, Number(cols) || 1) * Math.max(1, Number(rows) || 1) * Math.max(1, Number(nSlices) || 1)
  const smallSeries = voxels < 128 * 128 * 80 || (Number(nSlices) || 0) < 64

  if (h.phone) {
    // iOS / sin deviceMemory: conservador
    if (h.deviceMemory == null) return smallSeries ? 'mip' : 'off'
    if (h.deviceMemory < 4) return 'off'
    return 'mip'
  }

  if (h.deviceMemory != null && h.deviceMemory >= 4) return 'mip'
  if (!h.phone) return 'mip'
  return 'off'
}

export function mpr3dProfileLabel(profile) {
  if (profile === 'off') {
    return 'Memoria o GPU insuficiente para 3D en este dispositivo.'
  }
  return '3D con textura de volumen (WebGL2) o MIP.'
}

export function mpr3dProfileAllows(profile) {
  return profile === 'mip'
}
